<script setup lang="ts">
import { asText } from '@prismicio/client'
import type { Content } from "@prismicio/client";

defineProps(getSliceComponentProps<Content.ServiceGridSlice>());

const { client } = usePrismic()
const { data: services } = await useAsyncData('services-grid', async () => {
  const all = await client.getAllByType('service', {
    orderings: [{ field: 'my.service.order' }],
  })
  return all.filter((s) => !s.data.hide_in_grid)
})
</script>

<template>
  <section
      :data-slice-type="slice.slice_type"
      :data-slice-variation="slice.variation"
      :class="['pa-branch-grid', 'pa-branch-grid--' + slice.variation]"
  >
    <div class="pa-container">
      <div v-if="slice.primary.eyebrow || slice.primary.heading" class="pa-branch-grid__header">
        <div v-if="slice.primary.eyebrow" class="pa-branch-grid__eyebrow">
          {{ slice.primary.eyebrow }}
        </div>
        <div class="pa-branch-grid__heading">
          <PrismicRichText :field="slice.primary.heading" />
        </div>
      </div>

      <div class="pa-branch-grid__grid">
        <NuxtLink
            v-for="service in services"
            :key="service.id"
            :to="service.url || `/diensten/${service.uid}`"
            class="pa-branch-grid__card"
        >
          <div class="pa-branch-grid__card-content">
            <h3 class="pa-branch-grid__card-title">
              {{ asText(service.data.title) }}
            </h3>
            <hr class="pa-branch-grid__card-divider" />
            <span class="pa-branch-grid__card-arrow" aria-hidden="true">&rarr;</span>
          </div>
          <div class="pa-branch-grid__card-image">
            <PrismicImage
                v-if="service.data.featured_image?.url"
                :field="service.data.featured_image"
                :widths="[400, 600, 800, 1200]"
                sizes="(min-width: 1024px) 33vw, (min-width: 768px) 50vw, 100vw"
                :imgix-params="{ ar: '4:3', fit: 'crop', auto: 'format,compress' }"
            />
          </div>
        </NuxtLink>
      </div>
    </div>
  </section>
</template>
